import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { ProfilePresentation } from './ProfilePresentation';
import { ProfileFavouriteQuote } from './ProfileFavouriteQuote';
import { OrganisationPublicContent } from '../../generated/graphql';

export type ProfileProps = { id: number; publicContent: OrganisationPublicContent } & PropsWithChildren;

export function ProfilePageContent({ publicContent, children }: ProfileProps) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 2fr' },
                gap: '64px',
            }}
        >
            <ProfilePresentation
                content={publicContent}
                // 240px is the height of the profile image.
                // This calc is here to easily change this in relation to the original value
                boxProps={{ sx: { marginTop: 'calc(-240px/1.75)' } }}
            />
            <Box sx={{ paddingTop: '44px' }}>
                <ProfileFavouriteQuote quoteId={publicContent.favourite_quote_id} sx={{ marginBottom: '50px' }} />
                {children}
            </Box>
        </Box>
    );
}
